import { Subscription } from 'rxjs';

export enum FileStatus {
	PROCESSING = 'PROCESSING',
	EDITING = 'EDITING',
	COMPLETE = 'COMPLETE',
	DELETING = 'DELETING',
}

export type ExtendedFile = File &
	Partial<{
		id: string;
		progress: number;
		size: number;
		status: FileStatus;
		subscription: Subscription;
	}>;

export interface AllowedExtensions {
	allowedExtensions: string[];
}

export interface MaxFiles {
	maxFiles: number;
}
